import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@components/Input/Input';
import Button from '@components/Button/Button';
import { styled } from '@mui/material/styles';

// import ClearIcon from '@mui/icons-material/Clear';
// import CustomizedTextfield from '@components/custom.textfield/custom.textfield';
const Wrapper = styled('div')`
  .fullBtn {
    background-color: #2499e7;
    min-height: 50px;
    min-width: 172px;
    margin-top: 15px;
    padding: 10px 20px;
    color: white;
    font-family: 'Montserrat', sans-serif;
  }
  .fullBtn:hover {
    background-color: #208ad0;
  }

  .Mui-disabled {
    background-color: #bde0f8;
    color: white;
    font-weight: 600;
  }
`;
function CreateTeamModal({
  // classes,
  newTeamValue,
  setNewTeamValue,
  handleCreateNewTeam,
  loading,
}) {
  const enterFunc = (event) => {
    if (newTeamValue.trim() !== '' && event.keyCode === 13) {
      handleCreateNewTeam();
    }
  };

  useEffect(() => {
    window.addEventListener('keypress', enterFunc);
    return () => {
      window.removeEventListener('keypress', enterFunc);
    };
    // eslint-disable-next-line
  }, [newTeamValue]);

  return (
    <Wrapper>
      <div>
        <div className='text-md font-bold text-custom-font-color dark:text-white'>
          Team Name
        </div>
        <div className='w-100 pt-3'>
          {/* <CustomizedTextfield /> */}
          <TextField
            getValue={(event) => setNewTeamValue(event.target.value)}
            placeholder='My Team'
            value={newTeamValue}
            maxLength={30}
            helperText
            error={newTeamValue.length > 30}
          />
        </div>
        <div className='text-right'>
          <Button
            loading={loading}
            disabled={newTeamValue.trim() === '' || newTeamValue.length > 30}
            onClick={handleCreateNewTeam}
            className='fullBtn'
          >
            Create Team
          </Button>
        </div>
      </div>
    </Wrapper>
  );
}

CreateTeamModal.propTypes = {
  // classes: PropTypes.object,
  handleCreateNewTeam: PropTypes.func,
  loading: PropTypes.bool,
  newTeamValue: PropTypes.string,
  setNewTeamValue: PropTypes.func,
};

export default CreateTeamModal;
